export const PLACES_COUNTER = {
  '22': 5290,
  '24': 4276,
  '26': 3475,
  '21': 3262,
  '39': 2865,
  '17': 2574,
  '97': 2306,
  '35': 1954,
  '23': 1914,
  '31': 1638,
  '27': 1622,
  '20': 1459,
  '19': 1364,
  '16': 1337,
  '45': 1326,
  '41': 1294,
  '15': 1182,
  '95': 1053,
  '34': 895,
  '43': 831,
  '32': 729,
  '30': 725,
  '25': 427,
  '37': 415,
  '98': 400,
  '100': 394,
  '58': 327,
  '40': 249,
  '46': 223,
  '33': 210,
  '96': 207,
  '65': 168,
  '53': 160,
  '83': 119,
  '18': 108,
  '28': 95,
  '61': 75,
  '74': 67,
  '110': 54,
  '66': 52,
  '48': 50,
  '108': 48,
  '111': 46,
  '44': 43,
  '36': 39,
  '69': 38,
  '29': 34,
  '38': 29,
  '109': 26,
  '59': 22,
  '99': 21,
  '50': 19,
  '67': 18,
  '63': 17,
  '114': 13,
  '79': 8,
  '62': 6,
  '78': 5,
  '88': 5,
  '68': 5,
  '55': 4,
  '56': 4,
  '117': 4,
  '60': 3,
  '64': 3,
  '76': 3,
  '42': 2,
  '77': 2,
  '112': 2,
  '75': 2,
  '116': 2,
  '87': 1,
  '80': 1,
  '51': 1,
  '49': 1,
  '47': 1,
};

export const RETIVUT_PLACES_COUNTER = {
  '20': 1078,
  '39': 816,
  '21': 760,
  '19': 678,
  '25': 607,
  '26': 598,
  '16': 565,
  '27': 256,
  '24': 240,
  '45': 234,
  '22': 215,
  '15': 197,
  '66': 172,
  '46': 165,
  '62': 148,
  '74': 125,
  '17': 119,
  '63': 108,
  '38': 96,
  '75': 91,
  '44': 91,
  '29': 84,
  '43': 77,
  '23': 73,
  '48': 62,
  '85': 60,
  '69': 59,
  '32': 59,
  '34': 55,
  '28': 54,
  '30': 53,
  '55': 52,
  '84': 52,
  '56': 50,
  '40': 45,
  '68': 42,
  '99': 40,
  '77': 36,
  '31': 34,
  '76': 31,
  '67': 30,
  '35': 30,
  '96': 29,
  '88': 28,
  '41': 24,
  '18': 23,
  '58': 13,
  '78': 12,
  '112': 12,
  '59': 10,
  '83': 7,
  '113': 6,
  '87': 5,
  '97': 5,
  '60': 5,
  '36': 4,
  '53': 4,
  '50': 4,
  '49': 3,
  '80': 2,
  '111': 1,
  '95': 1,
  '98': 1,
  '61': 1,
  '79': 1,
  '51': 1,
  '89': 1,
  '82': 1,
  '42': 1,
};

export const DEFECTS_COUNTER = {
  '754': 1346,
  '5871': 965,
  '49': 960,
  '5168': 871,
  '65': 790,
  '53': 747,
  '41': 725,
  '52': 659,
  '61': 608,
  '63': 592,
  '84': 558,
  '96': 552,
  '3381': 543,
  '118811': 522,
  '55': 490,
  '1188': 488,
  '1385': 485,
  '60': 479,
  '100300': 464,
  '124': 454,
  '104694': 442,
  '74': 425,
  '117258': 391,
  '728': 385,
  '78': 379,
  '43': 378,
  '62': 373,
  '132': 369,
  '130648': 360,
  '742': 360,
  '130641': 354,
  '1375': 351,
  '75': 348,
  '104641': 346,
  '758': 341,
  '58': 330,
  '116': 327,
  '116650': 323,
  '1556': 321,
  '50': 317,
  '106': 310,
  '7854': 304,
  '77': 302,
  '118': 296,
  '111738': 294,
  '100316': 291,
  '111520': 266,
  '99197': 262,
  '114': 261,
  '45': 259,
  '140': 238,
  '1752': 233,
  '749': 224,
  '111112': 218,
  '38': 212,
  '119': 209,
  '110623': 201,
  '89': 200,
  '1200': 198,
  '137': 196,
  '104846': 194,
  '90': 193,
  '56': 192,
  '104620': 192,
  '1046': 188,
  '99217': 187,
  '130': 185,
  '102': 179,
  '767': 170,
  '111121': 163,
  '97': 162,
  '3761': 157,
  '81': 152,
  '91': 147,
  '143988': 144,
  '111132': 144,
  '113': 144,
  '122': 143,
  '137390': 138,
  '125': 137,
  '124666': 136,
  '8910': 135,
  '3341': 133,
  '105181': 133,
  '117': 133,
  '105196': 133,
  '164332': 132,
  '73': 132,
  '732': 131,
  '68': 131,
  '1280': 129,
  '181320': 123,
  '143979': 123,
  '97688': 120,
  '80': 118,
  '744': 117,
  '48': 116,
  '121': 115,
  '105283': 114,
  '143998': 114,
  '100264': 112,
  '137101': 108,
  '135328': 107,
  '6265': 105,
  '100302': 103,
  '100308': 103,
  '100307': 97,
  '3349': 96,
  '54': 94,
  '99215': 94,
  '88': 93,
  '135339': 93,
  '128': 92,
  '161931': 89,
  '3325': 88,
  '119863': 87,
  '69': 85,
  '100324': 84,
  '67': 84,
  '42': 80,
  '143': 78,
  '726': 76,
  '142': 76,
  '244': 75,
  '121719': 75,
  '1190': 72,
  '144569': 71,
  '178798': 69,
  '82': 69,
  '100325': 69,
  '64': 65,
  '145628': 65,
  '111709': 64,
  '5100': 64,
  '1048': 63,
  '751': 62,
  '130615': 61,
  '738': 59,
  '1987': 58,
  '1196': 57,
  '67327': 55,
  '137123': 55,
  '747': 54,
  '131261': 53,
  '130611': 53,
  '2512': 53,
  '3376': 52,
  '1204': 49,
  '101': 49,
  '128103': 49,
  '127': 48,
  '129730': 47,
  '6657': 46,
  '129703': 46,
  '59': 45,
  '57': 44,
  '6235': 44,
  '136808': 43,
  '155564': 43,
  '99224': 42,
  '161996': 42,
  '3319': 42,
  '86': 41,
  '128106': 41,
  '1504': 39,
  '117518': 38,
  '157778': 37,
  '126': 37,
  '36': 36,
  '76': 36,
  '116740': 35,
  '136479': 35,
  '110615': 35,
  '177397': 34,
  '100318': 34,
  '123': 33,
  '145656': 32,
  '117193': 32,
  '178670': 32,
  '143983': 32,
  '149195': 32,
  '40': 32,
  '220020': 31,
  '111127': 31,
  '163303': 31,
  '146632': 31,
  '100266': 30,
  '136464': 30,
  '734': 29,
  '172107': 29,
  '1640': 29,
  '116693': 29,
  '143975': 28,
  '83': 28,
  '178652': 28,
  '111619': 27,
  '159329': 27,
  '719': 27,
  '109': 27,
  '161879': 26,
  '100260': 26,
  '3335': 26,
  '108': 26,
  '120': 25,
  '107981': 25,
  '116686': 24,
  '104603': 24,
  '137098': 24,
  '130594': 24,
  '138': 24,
  '1182': 23,
  '124668': 23,
  '169359': 22,
  '141': 22,
  '135332': 22,
  '99195': 21,
  '176989': 20,
  '167413': 20,
  '99203': 19,
  '180053': 19,
  '87': 18,
  '131': 18,
  '174004': 18,
  '756': 17,
  '3360': 17,
  '116700': 17,
  '146626': 17,
  '157776': 17,
  '3418': 17,
  '3333': 17,
  '144000': 16,
  '114898': 16,
  '116660': 15,
  '109604': 15,
  '152230': 15,
  '1186': 15,
  '145649': 15,
  '71': 15,
  '150637': 15,
  '144': 15,
  '167435': 14,
  '70': 14,
  '130630': 13,
  '167431': 13,
  '176982': 13,
  '128108': 12,
  '115': 12,
  '99220': 12,
  '103919': 12,
  '139': 12,
  '150639': 11,
  '100': 11,
  '3327': 11,
  '4834': 11,
  '176986': 11,
  '130613': 11,
  '130608': 10,
  '130620': 10,
  '135': 10,
  '173043': 10,
  '178800': 10,
  '99849': 9,
  '131249': 8,
  '1198': 8,
  '105205': 8,
  '139123': 8,
  '724': 8,
  '134': 8,
  '72': 7,
  '10733': 7,
  '1945': 7,
  '66': 7,
  '130639': 6,
  '100309': 6,
  '111': 6,
  '103': 6,
  '238483': 6,
  '3843': 6,
  '130637': 6,
  '6183': 6,
  '99207': 6,
  '144753': 5,
  '130617': 5,
  '100317': 5,
  '139120': 5,
  '111129': 5,
  '99211': 5,
  '238472': 5,
  '116640': 5,
  '765': 4,
  '100326': 4,
  '178666': 4,
  '37': 4,
  '111747': 4,
  '1179': 4,
  '100301': 4,
  '168504': 4,
  '265328': 4,
  '99199': 4,
  '1184': 3,
  '68224': 3,
  '136': 3,
  '2020': 3,
  '3766': 3,
  '265633': 3,
  '99222': 3,
  '116677': 3,
  '100288': 3,
  '68231': 3,
  '189643': 3,
  '129': 3,
  '99213': 3,
  '109083': 3,
  '131252': 3,
  '242899': 3,
  '264107': 3,
  '100287': 3,
  '259297': 3,
  '105': 2,
  '68225': 2,
  '1194': 2,
  '8319': 2,
  '68222': 2,
  '105185': 2,
  '736': 2,
  '99209': 2,
  '68223': 2,
  '68214': 2,
  '112': 2,
  '100265': 2,
  '98': 2,
  '51': 2,
  '762': 2,
  '3331': 2,
  '110628': 2,
  '123877': 2,
  '99201': 2,
  '199990': 2,
  '174015': 2,
  '174006': 2,
  '164466': 2,
  '105192': 2,
  '174017': 2,
  '1192': 2,
  '130650': 2,
  '99205': 1,
  '100258': 1,
  '99': 1,
  '4794': 1,
  '6175': 1,
  '68213': 1,
  '79482': 1,
  '177828': 1,
  '68232': 1,
  '242901': 1,
  '253786': 1,
  '110': 1,
  '143968': 1,
  '2032': 1,
  '1202': 1,
  '1555': 1,
  '92': 1,
  '730': 1,
  '1991': 1,
  '265326': 1,
  '265324': 1,
  '153458': 1,
  '116682': 1,
  '143971': 1,
  '111125': 1,
  '269326': 1,
  '269328': 1,
  '116646': 1,
  '100289': 1,
};

export const RETIVUT_DEFECTS_COUNTER = {
  '12644': 2377,
  '12647': 1839,
  '12639': 1639,
  '12785': 1170,
  '12742': 1165,
  '12646': 1134,
  '25280': 787,
  '12716': 688,
  '12722': 680,
  '12752': 629,
  '25282': 622,
  '12741': 583,
  '97025': 543,
  '15174': 452,
  '12886': 372,
  '12699': 352,
  '124095': 347,
  '12743': 342,
  '117181': 328,
  '17112': 310,
  '17115': 272,
  '12658': 271,
  '12750': 233,
  '103282': 223,
  '25825': 214,
  '12663': 200,
  '12676': 183,
  '124089': 181,
  '12707': 172,
  '12675': 155,
  '213719': 155,
  '12760': 152,
  '12700': 141,
  '33685': 132,
  '103298': 121,
  '40324': 120,
  '103313': 113,
  '31632': 110,
  '12641': 109,
  '12715': 109,
  '12727': 100,
  '103280': 95,
  '12767': 91,
  '40404': 91,
  '17111': 88,
  '27298': 81,
  '12706': 67,
  '103283': 67,
  '17110': 65,
  '32774': 64,
  '40397': 59,
  '103281': 56,
  '12909': 55,
  '12708': 53,
  '103295': 52,
  '58720': 51,
  '213717': 51,
  '103309': 50,
  '12685': 48,
  '34416': 47,
  '103296': 47,
  '12690': 45,
  '12660': 45,
  '12642': 44,
  '12734': 44,
  '13380': 44,
  '17113': 40,
  '12661': 32,
  '97023': 32,
  '117179': 32,
  '12748': 32,
  '30578': 31,
  '12788': 30,
  '124097': 29,
  '12776': 29,
  '89375': 29,
  '12674': 26,
  '32509': 25,
  '156853': 24,
  '12782': 24,
  '12673': 24,
  '33403': 24,
  '12759': 23,
  '12688': 22,
  '12761': 22,
  '13038': 21,
  '89385': 20,
  '12768': 19,
  '211246': 19,
  '12698': 18,
  '12645': 18,
  '12643': 17,
  '12787': 17,
  '103297': 16,
  '16835': 15,
  '12766': 14,
  '124093': 14,
  '124105': 14,
  '124099': 13,
  '12662': 12,
  '103308': 12,
  '25418': 11,
  '25413': 11,
  '103307': 11,
  '213713': 11,
  '65692': 10,
  '213715': 10,
  '12758': 10,
  '12705': 9,
  '12749': 9,
  '12659': 9,
  '65664': 8,
  '124088': 7,
  '12686': 7,
  '12701': 7,
  '12777': 7,
  '117189': 6,
  '97027': 5,
  '12687': 5,
  '168065': 5,
  '92571': 5,
  '168274': 5,
  '12786': 5,
  '117185': 5,
  '79490': 4,
  '12728': 4,
  '117203': 4,
  '89379': 4,
  '156851': 4,
  '12689': 3,
  '30584': 3,
  '156857': 3,
  '12684': 3,
  '211524': 3,
  '206875': 3,
  '238044': 3,
  '12721': 3,
  '27296': 2,
  '124103': 2,
  '24272': 2,
  '211394': 2,
  '269111': 1,
  '12726': 1,
  '250072': 1,
  '268998': 1,
  '12778': 1,
  '15173': 1,
  '131471': 1,
  '12648': 1,
  '206874': 1,
  '12664': 1,
};
